module.exports = __webpack_public_path__ + "img/1.17f6ee93.png";